// ** React Imports
import { ReactNode } from 'react'

// ** MUI Imports
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import useMediaQuery from '@mui/material/useMediaQuery'
import { styled, useTheme } from '@mui/material/styles'

// ** Custom Components Imports
import CustomVerticalTab from 'src/components/aboutus/CustomVerticalTab'
import CustomLihatRekrutmen from 'src/components/shared/CustomLihatRekrutmen'

// ** Layout Import
import BlankLayoutAppBar from 'src/layouts/BlankLayoutWithAppBar'

const StyledImg = styled('img')(() => ({
  height: 100
}))

const AboutUs = () => {
  // ** Hooks
  const theme = useTheme()
  const hidden = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Grid container sx={{}}>
      <Grid
        item
        xs={12}
        sx={{
          py: 16,
          px: hidden ? 16 : 20,
          mb: 16,
          width: '100vw',
          backgroundColor: theme => theme.palette.primary.main,
          borderRadius: 1
        }}
      >
        <Typography
          variant='h4'
          fontWeight={600}
          textAlign={'center'}
          color={theme => theme.palette.secondary.main}
          letterSpacing={0}
          sx={{ mb: 6 }}
        >
          Raih Impianmu Bersama Bankaltimtara
        </Typography>
        <Typography
          variant='body1'
          textAlign={'center'}
          color={theme => theme.myColor?.white}
          letterSpacing={0}
          sx={{ p: 6 }}
          lineHeight={2}
        >
          PT Bank Pembangunan Daerah Kalimantan Timur dan Kalimantan Utara disingkat dengan sebutan Bankaltimtara,
          merupakan salah satu Badan Usaha Milik Daerah yang dimiliki oleh Pemerintah Provinsi Kalimantan Timur,
          Pemerintah Provinsi Kalimantan Utara, Pemerintah Kabupaten/Kota se Kalimantan Timur dan Pemerintah
          Kabupaten/Kota se Kalimantan Utara, dan telah memiliki lebih dari 200 jaringan kantor yang berada di wilayah
          Kalimantan Timur, Kalimantan Utara dan Jakarta.
        </Typography>
        <Typography
          variant='body1'
          textAlign={'center'}
          color={theme => theme.myColor?.white}
          letterSpacing={0}
          sx={{ p: 6 }}
          lineHeight={2}
        >
          Bankaltimtara saat ini memiliki Asset diatas 25 Triliun dan masuk peringkat ke 5 besar bank dengan asset
          tertinggi BPD seluruh Indonesia. Dengan pengelolaan Sumber Daya Manusia yang baik, Bankaltimtara memberikan
          peluang karir dan pengembangan diri yang terbuka luas. Seiring pertumbuhan organisasi yang pesat,
          Bankaltimtara membutuhkan profesional muda yang kreatif, inovatif, berdedikasi dan berintegritas tinggi untuk
          maju dan berkembang bersama dalam mewujudkan visi Bankaltimtara "Menjadi The True Regional Champion yang Kuat,
          Kompetitif dan Kontributif dalam mendukung pertumbuhan ekonomi daerah yang berkualitas”
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ mb: 16 }}>
        <Grid container>
          <Grid item xs={12} sx={{ mb: 6 }}>
            <Typography
              variant='h4'
              fontWeight={600}
              textAlign={'center'}
              color={theme => theme.palette.primary.main}
              letterSpacing={0}
            >
              Visi & Misi Bankaltimtara
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ mb: 6 }}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item xs={12} sm={3} md={2} sx={{ mb: 4 }}>
                    <img src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/visi.svg`} alt='Visionary technology' />
                  </Grid>
                  <Grid item xs={12} sm={9} md={10} sx={{ px: 6, alignSelf: 'center' }}>
                    <Typography
                      variant='h4'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                      sx={{ mb: 2 }}
                    >
                      Visi
                    </Typography>
                    <Typography variant='body1' letterSpacing={0}>
                      “Menjadi The True Regional Champion yang Kuat, Kompetitif dan Kontributif dalam mendukung
                      pertumbuhan ekonomi daerah yang berkualitas dan berkelanjutan”
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sx={{ mb: 6 }}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item xs={12} sm={9} md={10} sx={{ px: 6, alignSelf: 'center' }}>
                    <Typography
                      variant='h4'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                      sx={{ mb: 2 }}
                    >
                      Misi
                    </Typography>
                    <Grid container columns={24} rowSpacing={4}>
                      <Grid item xs={2} sm={1}>
                        1.
                      </Grid>
                      <Grid item xs={22} sm={23}>
                        Mengembangkan bisnis dan layanan perbankan yang berorientasi solusi dan berbasis teknologi.
                      </Grid>
                      <Grid item xs={2} sm={1}>
                        2.
                      </Grid>
                      <Grid item xs={22} sm={23}>
                        Menjadi pendukung utama program pembangunan ekonomi dan menopang pemberdayaan perekonomian
                        rakyat.
                      </Grid>
                      <Grid item xs={2} sm={1}>
                        3.
                      </Grid>
                      <Grid item xs={22} sm={23}>
                        Membudayakan filosofi kerja yang berorientasi pada prestasi.
                      </Grid>
                      <Grid item xs={2} sm={1}>
                        4.
                      </Grid>
                      <Grid item xs={22} sm={23}>
                        Menjaga dan meningkatkan reputasi Bank.
                      </Grid>
                      <Grid item xs={2} sm={1}>
                        5.
                      </Grid>
                      <Grid item xs={22} sm={23}>
                        Memperkuat ketahanan kelembagaan melalui pelaksanaan kepatuhan dan manajemen risiko yang
                        berkualitas.
                      </Grid>
                      <Grid item xs={2} sm={1}>
                        6.
                      </Grid>
                      <Grid item xs={22} sm={23}>
                        Mendorong penerapan prinsip keuangan berkelanjutan dalam aktivitas dan bisnis Bank.
                      </Grid>
                      <Grid item xs={2} sm={1}>
                        7.
                      </Grid>
                      <Grid item xs={22} sm={23}>
                        Meningkatkan kepedulian sosial bagi komunitas dan lingkungan sekitar.
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={3} md={2} sx={{ alignSelf: 'center' }}>
                    <img src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/misi.svg`} alt='Visionary technology' />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mb: 16 }}>
        <Grid container>
          <Grid item xs={12} sx={{ mb: 6 }}>
            <Typography
              variant='h4'
              fontWeight={600}
              textAlign={'center'}
              color={theme => theme.palette.primary.main}
              letterSpacing={0}
            >
              6 Nilai Utama Bankaltimtara
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ mb: 6 }}>
            <Grid container spacing={6}>
              <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ mb: 6 }}>
                    <StyledImg
                      src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/championship.svg`}
                      alt='Championship'
                    />
                    <Typography
                      variant='h6'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                    >
                      Championship
                    </Typography>
                    <Typography variant='body1' letterSpacing={0}>
                      Mempunyai semangat juang untuk selalu menjadi juara
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ mb: 6 }}>
                    <StyledImg src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/creativity.svg`} alt='Creativity' />
                    <Typography
                      variant='h6'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                    >
                      Creativity
                    </Typography>
                    <Typography variant='body1' letterSpacing={0}>
                      Kreatif dalam mengembangkan produk dan layanan perbankan
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ mb: 6 }}>
                    <StyledImg src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/caring.svg`} alt='Caring' />
                    <Typography
                      variant='h6'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                    >
                      Caring
                    </Typography>
                    <Typography variant='body1' letterSpacing={0}>
                      Memiliki rasa kepedulian yang tinggi terhadap sesama insan Bankaltimtara
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ mb: 6 }}>
                    <StyledImg src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/character.svg`} alt='Character' />
                    <Typography
                      variant='h6'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                    >
                      Character
                    </Typography>
                    <Typography variant='body1' letterSpacing={0}>
                      Meletakkan karakter sebagai basis pengembangan reputasi, baik institusi maupun perorangan
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ mb: 6 }}>
                    <StyledImg src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/citizenship.svg`} alt='Citizenship' />
                    <Typography
                      variant='h6'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                    >
                      Citizenship
                    </Typography>
                    <Typography variant='body1' letterSpacing={0}>
                      Mempunyai rasa tanggung jawab yang tinggi sebagai warga korporasi yang baik
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ mb: 6 }}>
                    <StyledImg src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/customer.svg`} alt='Customer Focus' />
                    <Typography
                      variant='h6'
                      fontWeight={600}
                      color={theme => theme.palette.primary.main}
                      letterSpacing={0}
                    >
                      Customer Focus
                    </Typography>
                    <Typography variant='body1' letterSpacing={0}>
                      Menjadikan kepentingan nasabah sebagai dasar setiap kegiatan bisnis
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mb: 8 }}>
        <Card
          sx={{
            backgroundColor: theme => theme.palette.primary.main,
            backgroundImage: `url(${process.env.NEXT_PUBLIC_BASE_PATH}/images/cardbg.svg)`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        >
          <CardContent>
            <Typography
              variant='h6'
              fontWeight={600}
              color={theme => theme.myColor?.white}
              letterSpacing={0}
              sx={{ mb: 4 }}
            >
              Meaning Statement
            </Typography>
            <Typography
              variant='h4'
              color={theme => theme.myColor?.white}
              letterSpacing={0}
              sx={{
                p: 4,
                borderLeftStyle: 'solid',
                borderLeftWidth: 6,
                borderColor: theme => theme.palette.secondary.main
              }}
            >
              “Mengabdi Untuk Kesejahteraan Bersama”
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sx={{ mb: 36 }}>
        <Card
          sx={{
            backgroundColor: theme => theme.palette.primary.main,
            backgroundImage: `url(${process.env.NEXT_PUBLIC_BASE_PATH}/images/cardbg.svg)`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        >
          <CardContent>
            <Typography
              variant='h6'
              textAlign='right'
              fontWeight={600}
              color={theme => theme.myColor?.white}
              letterSpacing={0}
              sx={{ mb: 4 }}
            >
              Tagline
            </Typography>
            <Typography
              variant='h4'
              textAlign='right'
              color={theme => theme.myColor?.white}
              letterSpacing={0}
              sx={{
                p: 4,
                borderRightStyle: 'solid',
                borderRightWidth: 6,
                borderColor: theme => theme.palette.secondary.main
              }}
            >
              “Memajukan Kalimantan, Memajukan Indonesia”
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sx={{ mb: 36 }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              variant='h4'
              fontWeight={600}
              color={theme => theme.palette.primary.main}
              letterSpacing={0}
              sx={{ mb: 6 }}
            >
              Jajaran Pengurus & Direksi Bankaltimtara
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <CustomVerticalTab />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mb: 16 }}>
        <CustomLihatRekrutmen />
      </Grid>
    </Grid>
  )
}

AboutUs.getLayout = (page: ReactNode) => <BlankLayoutAppBar>{page}</BlankLayoutAppBar>

AboutUs.authGuard = false

export default AboutUs
